import { createSlice } from '@reduxjs/toolkit';
import { OMSAPI } from '../../../API';
import { LABELGENAPI, LABELINGCHIMP_SAM_API, LABELINGCHIMP_LABEL_API } from '../../../API';
import axios from 'axios';
import { logFrontendActivity } from '../../General/activityLogger';

/* canceling previous requests if multiple requests is triggered */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const rateslice = createSlice({
    name: 'rate',
    initialState: {
        data: [],
        meta: [],        
        loading: false,
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getRate: (state) => {
            return {
                ...state,
                loading: true,
                // hasErrors: false,
                data: [],
            }
        },
        getRateSuccess: (state, action) => {
            // 1. Identify the HTTP status and payload data
            const status = action?.payload?.status || action?.status;
            const payloadData = action?.payload?.data;

            // 2. Safety check: Handle 500 error or missing payload
            if (status === 500 || !payloadData) {
                return {
                    ...state,
                    loading: false,
                    data: [], // Reset to empty array to prevent .map() crashes in UI
                    notification: {
                        show: true,
                        // Changed to array format as requested
                        messageContent: ["Internal Server Error. Unable to retrieve rates."], 
                        messageType: "error",
                        status: status || 500
                    }
                };
            }

            // 3. Robust path mapping for rates
            const rates = payloadData?.message?.rates;

            return {
                ...state,
                loading: false,
                // Ensure data is always an array, even if the path is missing
                data: Array.isArray(rates) ? rates : [], 
                notification: { 
                    show: false, 
                    messageContent: [], // Keep consistent as an empty array
                    messageType: "success" 
                }
            };
        },
        getRateFailure: (state, action) => {
            const payloadData = action?.payload?.data;
            let errorMessages = [];

            if (payloadData) {
                // 1. Check if 'errors' is an object (common in 422 Validation errors)
                if (payloadData.errors && typeof payloadData.errors === "object" && !Array.isArray(payloadData.errors)) {
                    // Extract all values from the error object (e.g., postal_code messages)
                    Object.values(payloadData.errors).forEach(errValue => {
                        if (Array.isArray(errValue)) {
                            errorMessages.push(...errValue);
                        } else {
                            errorMessages.push(String(errValue));
                        }
                    });
                } 
                // 2. Fallback if 'errors' is directly an array
                else if (Array.isArray(payloadData.errors) && payloadData.errors.length > 0) {
                    errorMessages = payloadData.errors;
                }
                // 3. Fallback to the top-level 'message' string
                else if (payloadData.message) {
                    errorMessages = [payloadData.message];
                }
            }

            // Final fallback if nothing was found
            if (errorMessages.length === 0) {
                errorMessages = ["Unknown error occurred"];
            }

            return {
                ...state,
                loading: false,
                notification: {
                    show: true,
                    // UI will map through this array
                    messageContent: errorMessages,
                    messageType: "error"
                }
            };
        },
        resetRate: (state) => {
            return {
                ...state,
                loading: false,
                notification: { show: false, messageContent: "", messageType: "success" },
                data:[]
            }
        },



    }
})
export const { getRate, getRateSuccess, getRateFailure,resetRate } = rateslice.actions;

export const doGetRate = (reportName, userid, orderid, data, api_token) => {
    return (dispatch) => {
        dispatch(getRate());
        const logRef = crypto.randomUUID();
        try {
            LABELINGCHIMP_SAM_API
                .post('/rates', data, { 
                    headers: { 
                        'x-api-key': api_token, 
                        'Content-Type': 'application/json' 
                    } 
                })
                .then(function (response) {
                    dispatch(getRateSuccess(response));
                    
                    // logFrontendActivity({
                    //     group: 'FETCH_RATES',
                    //     subgroup: reportName,
                    //     action: 'SUCCESS',
                    //     request_data: data,
                    //     response_data: response.data,
                    //     log_ref: logRef,
                    //     userid: userid,
                    //     orderid : orderid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     } else {
                    //         console.log('Activity log failed:', ref);
                    //     }
                    // });
                })
                .catch(function (error) {
                    dispatch(getRateFailure(error.response));
                    // dispatch(resetNotification());

                    // logFrontendActivity({
                    //     group: 'FETCH_RATES',
                    //     subgroup: reportName,
                    //     action: 'FAILURE',
                    //     request_data: data,
                    //     response_data: error.response?.data || {},
                    //     log_ref: logRef,
                    //     userid: userid,
                    //     orderid : orderid
                    // }).then((ref) => {
                    //     if (ref) {
                    //         console.log('Activity log recorded with log_ref:', ref);
                    //     }
                    // });
                });
        } catch (error) {
            dispatch(getRateFailure(error.response));
            // dispatch(resetNotification());

            // logFrontendActivity({
            //     group: 'FETCH_RATES',
            //     subgroup: reportName,
            //     action: 'FAILURE',
            //     request_data: data,
            //     response_data: error.response?.data || {},
            //     log_ref: logRef,
            //     userid: userid,
            //     orderid : orderid
            // }).then((ref) => {
            //     if (ref) {
            //         console.log('Activity log recorded with log_ref:', ref);
            //     }
            // });
        }
    };
};
export const resetRateState = data => dispatch => {    
    dispatch(resetRate());
}



export default rateslice.reducer;
